var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEyeVisible = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.087 6.569c.773.813.773 2.049 0 2.862-1.304 1.372-3.543 3.236-6.087 3.236-2.544 0-4.783-1.864-6.087-3.236a2.056 2.056 0 0 1 0-2.862C3.217 5.197 5.456 3.333 8 3.333c2.544 0 4.783 1.864 6.087 3.236Z",
  stroke: "currentColor",
  strokeWidth: 1.5
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
  stroke: "currentColor",
  strokeWidth: 1.5
})));
export default SvgEyeVisible;